module.exports = __webpack_public_path__ + "static/media/print_bg.27aa9228.png";